<script>
import ToggleButton from "@/components/ToggleButton";

export default {
  name: "GlyphProtectedRowButtonGroup",
  components: {
    ToggleButton,
  },
  data() {
    return {
      protectedRows: 0,
      moveGlyphs: false,
    };
  },
  computed: {
    questionMarkTooltip() {
      return `Protected slots are unaffected by anything which may move or purge Glyphs.
        New Glyphs will never be inserted into these slots.`;
    },
  },
  watch: {
    moveGlyphs(newValue) {
      player.reality.moveGlyphsOnProtection = newValue;
    },
  },
  methods: {
    update() {
      this.moveGlyphs = player.reality.moveGlyphsOnProtection;
      this.protectedRows = player.reality.glyphs.protectedRows;
    },
    addRow() {
      Glyphs.changeProtectedRows(1);
    },
    removeRow() {
      Glyphs.changeProtectedRows(-1);
    },
    isProtectedRowsMax() {
      return this.protectedRows === Glyphs.totalSlots / 10 - 1;
    },
    addRowButtonClass() {
      return {
        "c-glyph-inventory-option": true,
        "o-non-clickable": this.isProtectedRowsMax(),
      };
    },
    removeRowButtonClass() {
      return {
        "c-glyph-inventory-option": true,
        "o-non-clickable": this.protectedRows === 0,
      };
    },
  },
};
</script>

<template>
  <div class="o-glyph-inventory-management-group">
    <div class="l-glyph-sacrifice-options__header">
      <div v-tooltip="questionMarkTooltip" class="o-questionmark">?</div>
      Protected Slots: ({{ quantifyInt("row", protectedRows) }})
    </div>
    <button :class="addRowButtonClass()" @click="addRow">
      Add a protected row
      <div v-if="isProtectedRowsMax()" class="c-glyph-inventory-option__tooltip">
        One row is permanently un-protected for new Glyphs
      </div>
    </button>
    <button :class="removeRowButtonClass()" @click="removeRow">Remove a protected row</button>
    <ToggleButton v-model="moveGlyphs" class="c-glyph-inventory-option" label="Move Glyphs on changing row count:" />
  </div>
</template>

<style scoped>
.o-non-clickable {
  cursor: auto;
}
</style>
